import { Injectable, inject } from '@angular/core';
import { SaveDashboardPreferencesRequest } from '@interfaces/dashboard-preferences/requests/save-dashboard-preferences.request';
import { DashboardPreferencesResponse } from '@interfaces/dashboard-preferences/responses/dashboard-preferences.response';
import { VaultApiService } from '@services/api/vault-api.service';
import { Observable } from 'rxjs';

/**
 * Arrumação da Home do usuário logado (`dashboard/preferences`, card 3788): ordem dos blocos e quais estão ligados.
 *
 * <remarks>
 * As duas rotas exigem `DASHBOARDPREFERENCES_MANAGE` e valem só para o usuário do token. Quem consome é o
 * `HomeLayoutService` da Home; sem a permissão ele nem chama e guarda a arrumação no navegador.
 * </remarks>
 */
@Injectable({ providedIn: 'root' })
export class DashboardPreferencesHttpService {
  private readonly baseUrl = 'dashboard/preferences';
  private readonly apiService = inject(VaultApiService);

  /** Arrumação gravada (lista vazia quando o usuário nunca personalizou). */
  get(): Observable<DashboardPreferencesResponse | null> {
    return this.apiService.get<DashboardPreferencesResponse>(this.baseUrl);
  }

  /**
   * Grava a arrumação inteira (cria ou substitui) e devolve o que ficou gravado.
   * @param request Blocos na ordem nova, com `visible`.
   */
  save(request: SaveDashboardPreferencesRequest): Observable<DashboardPreferencesResponse | null> {
    return this.apiService.put<DashboardPreferencesResponse>(this.baseUrl, request);
  }
}
